export default __webpack_public_path__ + "static/media/guy-presenting.55b4e6f5.png";